import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormControl,
  FormGroup,
  FormGroupDirective,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { User } from 'src/app/_models/user.model';
import { AuthenticationService } from 'src/app/_services';
import { PhotoService } from 'src/app/_services/photo.service';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { ImagePreviewComponent } from '../image-preview/image-preview.component';

@Component({
  selector: 'app-upload-attachment',
  templateUrl: './upload-attachment.component.html',
  styleUrls: ['./upload-attachment.component.scss'],
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective },
  ],
})
export class UploadAttachmentComponent
  implements OnInit, AfterViewInit, OnChanges {
  constructor(
    public photoService: PhotoService,
    public modalController: ModalController,
    public p: ThisPlatform,
    private ctrlContainer: FormGroupDirective,
    private formBuilder: FormBuilder,
    private translateService: TranslateService,
    private authService: AuthenticationService
  ) {}

  formGroup: FormGroup; // Pomocnicze dla Walidacji
  public file: File;
  @Input()
  multiple = false;

  /**
   * Array of attachment [multiple == true] or attachment [multiple == false] eq:
   * [{fileName: 'xxx', filePath: 'yyy'}, {fileName: 'zzz', filePath: 'aaa'}] or
   * {fileName: 'xxx', filePath: 'yyy'}
   */

  @Input()
  attachment: any = null;

  @Input()
  uploadAttachmentButtonText;

  @Input()
  changeAttachmentButtonText;

  @Input()
  takePhotoOption = false;

  @Input()
  readonly = false;

  @Input()
  avatar = false;

  @Input()
  user: User;

  @Output()
  attachmentUploaded: EventEmitter<File> = new EventEmitter<File>();

  @Output()
  attachmentRemoved: EventEmitter<number> = new EventEmitter<number>();

  @Input('controlName')
  formControlName: string;

  @ViewChild('fileInput')
  fileInput;

  viewChangeImage = false;
  photoIndex: number;
  isPhoto = false;

  id = 'id';

  ngOnInit() {
    if (
      !this.multiple &&
      !this.attachment?.name &&
      !this.attachment?.filename
    ) {
      this.attachment = null;
    }

    this.formGroup = this.ctrlContainer.form;
    const control = new FormControl('');
    this.formGroup.addControl(this.formControlName, control);

    if (!this.user)
      this.authService.currentUser.subscribe(async (user) => {
        this.user = { ...user };
      });

    this.id += Math.random().toString();
  }

  ngAfterViewInit(): void {
    // window.setTimeout(() => {
    // }, 5000);
  }

  fileUpload(event) {
    this.uploadFile(event);
  }

  onFileChanged(event) {
    this.uploadFile(event.target.files[0]);
  }

  uploadFile(file: File) {
    this.file = file;
    this.formGroup
      .get('itemImage')
      .setValue(file, { emitModelToViewChange: false });
    if (!file) {
      return;
    }

    this.attachmentUploaded.emit(file);
    this.preview(file);

    this.file = null;
    this.isPhoto = true;
  }

  takePicture() {
    this.photoService.currentImage = this.photoService.fileImage = null;
    this.photoService.takePicture(() => {
      if (this.photoService.currentImage && this.photoService.fileImage) {
        this.attachmentUploaded.emit(this.photoService.fileImage);
        this.preview(this.photoService.fileImage);
        this.isPhoto = true;
      }
    });
  }

  removeAttachement(key: number) {
    if (this.multiple) {
      if (this.attachment.length > key) {
        this.attachment.splice(key, 1);
      }
    } else {
      this.attachment = null;
      this.user.avatar = null;
    }

    this.attachmentRemoved.emit(key);
    this.fileInput.nativeElement.value = null;
    this.formGroup
      .get('itemImage')
      .setValue(null, { emitModelToViewChange: false });
    this.isPhoto = false;
  }

  preview(file: File) {
    const mimeType = file.type;

    if (mimeType.match(/image\/*/) == null) {
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (_event) => {
      const attachment = { filePath: reader.result, fileName: '' };

      // setTimeout(() => {
      if (this.multiple) {
        this.attachment.push(attachment);
      } else {
        this.attachment = attachment;
      }
      // }, 0);
    };
  }

  async modalPreview(key: number) {
    let url = '';

    if (this.multiple) {
      url =
        this.attachment && this.attachment[key]
          ? this.attachment[key].filePath
          : '';
    } else {
      url = this.attachment ? this.attachment.filePath : '';
    }

    if (!url || url.length == 0) {
      return;
    }

    const modal = await this.modalController.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: 'image-preview-present',
    });
    modal.present();
  }
  canAdd() {
    if (!this.multiple) {
      return true;
    }
    if (this.attachment?.length < 5) {
      return true;
    }
    return false;
  }

  ngOnChanges(changes: SimpleChanges): void {}
}
